import { useGetServiceCatalogQuery } from '@shared/services/serviceCatalogs';

const useServiceCatalog = (skip: boolean) => {
  const { data, isFetching, isLoading, error } = useGetServiceCatalogQuery(undefined, {
    skip,
  });

  const getService = (code: string) => data?.find((s) => s.Code === code);

  return { getService, isFetching, isLoading, error };
};

export default useServiceCatalog;
